import { Queries } from "../api";
import {
  setOptionsList,
  setClientValue,
  setHomeValue,
  showInnerLoading,
} from "../actions";
import { cityCodes } from "../helpers";
import { quoters } from '../ecosystem.config';

export function getOccupations() {
  return function func(dispatch) {
    return Queries.getOccupations().then(response => {
      if (response) {
        dispatch(setOptionsList('occupations', response));
      }
    });
  };
}

function getCities(department) {
  return function func(dispatch) {
    return Queries.getCities(department.value).then(response => {
      if (response) {
        dispatch(setOptionsList('cities', response));
      }
    });
  };
}

export function getDepartments(reducer = 'client') {
  return function func(dispatch, getState) {
    const { client, home } = getState();
    
    let addressState;
    switch(reducer) {
      case 'client': addressState = client.addressState; break;
      case 'home': addressState = home.addressState; break;
    }

    return Queries.getDepartments().then(response => {
      if (response) {
        dispatch(setOptionsList('departments', response));
        if(addressState) dispatch(getCities(addressState));
      }
    });
  };
}

export function getStreetsAsync(addressState, addressCity, strSearch) {
  return new Promise((resolve) => {
    resolve(
      Queries.getStreets(addressState.value, addressCity.value, strSearch).then((response) => {
        if (response) {
          const options = response.map((obj) => {
            let rObj = {};
            rObj['value'] = obj.clave;
            rObj['label'] = obj.valor;
            return rObj;
          });

          return options;
        } else {
          return [];
        }
      })
    );
  });
}

export function getStreets(strSearch, reducer = 'client', isMDV = false) {
  return function func(dispatch, getState) {
    const { client, home } = getState();
    
    let addressCity, addressState;
    switch(reducer) {
      case 'client': 
        addressCity = client.addressCity; 
        addressState = client.addressState; 
        break;
      case 'home': 
        addressCity = isMDV ? {value: '1'} : home.addressCity; 
        addressState = home.addressState; 
        break;
    }
    
    return Queries.getStreets(addressState.value, addressCity.value, strSearch).then(response => {
      if (response) dispatch(setOptionsList('streets', response));
    });
  };
}

export function setDepartment(department, reducer = 'client') {
  return function func(dispatch, getState) {
    const { client, home, options } = getState();
    const { addressState: stateClient } = client;
    const { addressState: stateHome } = home;
    
    let addressState = null;
    switch(reducer) {
      case 'client': addressState = stateClient; break;
      case 'home':   addressState = stateHome;   break;
    }

    if(!(addressState && department && addressState.value === department.value)){
      
      let setValue = null;
      switch(reducer) {
        case 'client': setValue = setClientValue; break;
        case 'home':   setValue = setHomeValue;   break;
      }
      
      dispatch(setValue('addressState',  department));
      dispatch(setValue('addressCity',   null));
      dispatch(setValue('addressStreet', null));

      if ((options.quoter === quoters.PYME.key ||
           options.quoter === quoters.PYMEFARMACIA.key) &&
           department && department.label !== 'CANELONES') {
          const city = cityCodes.find(city => {return city.label === department.label});
          if(city) dispatch(setValue('addressCity', {value: city.code, label: city.label}));
      }

      if(department) dispatch(getCities(department));
    }
  };
}

export function setCity(city, reducer = 'client', isMVD = false) {
  return function func(dispatch, getState) {
    const { client, home } = getState();
    const { addressCity: cityClient } = client;
    const { addressCity: cityHome } = home;
    
    let addressCity = null;
    switch(reducer) {
      case 'client': addressCity = cityClient; break;
      case 'home':   addressCity = cityHome;   break;
    }

    if(!(addressCity && city && addressCity.value === city.value)) {

      let setValue = null;
      switch(reducer) {
        case 'client': setValue = setClientValue; break;
        case 'home':   setValue = setHomeValue;   break;
      }

      dispatch(setValue('addressCity', city));
      dispatch(setValue('addressStreet', null));

      if(city) dispatch(getStreets({ label: '', value: '' }, reducer, isMVD));
    }
  };
}

export function getMontevideoNeighborhoods() {
  return function func(dispatch) {
    dispatch(showInnerLoading(true));
    return Queries.getMontevideoNeighborhoods().then(response => {
      if (response && response.length) {
        dispatch(setHomeValue('montevideoNeighborhoods', response));
      }
      dispatch(showInnerLoading(false));
  });
  };
}

export function getFireOptions() {
  return function func(dispatch) {
    dispatch(showInnerLoading(true));
    return Queries.getFireOptions().then(response => {
      if (response && response.length) {
        dispatch(setHomeValue('fireOptions', response));
      }
      dispatch(showInnerLoading(false));
  });
  };
}

export function getTheftOptions() {
  return function func(dispatch) {
    dispatch(showInnerLoading(true));
    return Queries.getTheftOptions().then(response => {
      if (response && response.length) {
        dispatch(setHomeValue('theftOptions', response));
      }
      dispatch(showInnerLoading(false));
  });
  };
}